//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { IUserSession, UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { TaskTypeController, TaskTypeScope } from './tasks-types.controller'
import { TaskTypeCreateEditDirective } from './create-edit/tasks-types-create-edit.directive'
import { TaskTypeDetailsDirective } from './details/tasks-types-details.directive'

import { TaskTypeHelper } from './tasks-types.helper'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive';
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './tasks-types.tpl.html'

//#endregion

// Consts

const CONTROLLER_NAME: string = 'TaskTypeController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'taskTypeCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'taskTypeDetails'
const MODULE_NAME: string = 'simax.tasks-types'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'TASK_TYPE_NAME'
const STATE_NAME: string = 'tasksTypes'
const STATE_URL: string = '/tasksTypes'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [$SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'api', 'localDictionary', USER_SESSION_SERVICE_NAME, SYSTEM_SERVICE_NAME, (
    $scope: TaskTypeScope,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    api: Api,
    localDictionary: LocalDictionaryFactory,
    userSession: IUserSession,
    systemService: SystemService
) => new TaskTypeController(
    $scope,
    $state,
    $timeout,
    api,
    localDictionary,
    userSession,
    systemService,
    TaskTypeHelper.REFERENCE_TYPE,
    TaskTypeHelper.SIMAX_MODULE_NAME
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new TaskTypeDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new TaskTypeCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Task_Type_IdTaskType',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.TASK_TYPE_LIST)
                && !loggedOperator.hasPermission(Activity.TASK_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskTypeModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.LOCATION_TYPE),
                    'tasksTypes',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME